<mat-form-field>
	<mat-label>
		<span [cmLocalize]="localizationPrefix + '.FieldLabel.Search'">
			Search
		</span>
	</mat-label>
	<input type="text" matInput #searchInp [formControl]="searchControl" />
	<ats-icon name="search" matPrefix></ats-icon>
	<button *ngIf="searchInp.value" mat-icon-button matSuffix (click)="clear()"
		[attr.aria-label]="'Clear' | cmLocalize: localizationPrefix + '.Button.Clear'"
		[matTooltip]="'Clear' | cmLocalize: localizationPrefix + '.Button.Clear'">
		<ats-icon name="close"></ats-icon>
	</button>
</mat-form-field>
